import { forwardRef, useState } from 'react';
import InnerDrawer from './components/inner-drawer';

type DetailsLayoutWrapperProps = {
  children: React.ReactNode;
  drawerChildren?: React.ReactNode;
};

const DetailsLayoutWrapper = forwardRef<HTMLDivElement, DetailsLayoutWrapperProps>(
  ({ children, drawerChildren }, ref) => {
    const hasDrawer = Boolean(drawerChildren);
    const [drawerOpen, setDrawerOpen] = useState(hasDrawer);

    const handleDrawerToggle = () => {
      setDrawerOpen(currentOpen => !currentOpen);
    };

    return (
      <div
        className="bg-secondary h-full overflow-hidden flex flex-col [--drawer-width:0px] md:block md:[--drawer-width:450px] md:data-[has-drawer=true]:grid data-[has-drawer=true]:[grid-template-areas:'drawer_content'] data-[has-drawer=true]:transition-[grid-template-columns] data-[has-drawer=true]:duration-200 data-[has-drawer=true]:ease-in-out"
        style={
          hasDrawer
            ? {
                gridTemplateColumns: drawerOpen ? 'var(--drawer-width) 1fr' : '1px 1fr',
              }
            : undefined
        }
        data-has-drawer={hasDrawer}
      >
        {drawerChildren && (
          <InnerDrawer open={drawerOpen} onClose={handleDrawerToggle} onOpenChange={setDrawerOpen}>
            <div className="flex flex-col gap-6 p-4 md:p-6">{drawerChildren}</div>
          </InnerDrawer>
        )}
        <div
          ref={ref}
          className="flex justify-center w-full flex-1 min-h-0 md:flex-none md:min-h-auto md:h-full bg-secondary p-4 md:p-6 overflow-y-auto relative"
        >
          {children}
        </div>
      </div>
    );
  },
);

export default DetailsLayoutWrapper;
